import React from 'react';

function Footer({
  onNavigate,
  currentPage,
  navSource,
  whitelistEnabled = false,
  onWhitelistBlocked = () => {},
  hasLiveGame = false,
  hasTaskReward = false,
})
{
  const go = (page) => {
    if (whitelistEnabled && page !== 'home') {
      onWhitelistBlocked(page);
      return;
    }
    onNavigate(page);
  };

  return (
  <>
    <footer className="footer">
     <button
  className={`footer-btn footer-btn-1 ${
    [
      "gamesHub",
      "home",
      "memoryGame",
      "fortuneWheel",
      "hiddenSeek",
      "holidayevent",
      "tournaments",
      "events",
      "streakevent",
    ].includes(currentPage)
      ? "active"
      : ""
  }`}
  onClick={() => go("gamesHub")}
  style={{ position: "relative" }}
>
  <i></i>

  {hasLiveGame && (
    <span
      className="footer-live-dot"
      aria-label="Live game available"
    />
  )}

  GAMES
</button>
      <button className={`footer-btn footer-btn-2 ${currentPage === 'shop' ? 'active' : ''}`} onClick={() => onNavigate('shop')}>
        <i></i>
        SHOP
      </button>
      <button className={`footer-btn footer-arena footer-btn-5 ${currentPage === 'arenas' ? 'active' : ''}`} onClick={() => onNavigate('arenas')}>
        <i></i>
        ARENA
      </button>
      <button className={`footer-btn footer-btn-3 ${currentPage === 'inventoryHub' ? 'active' : ''}`} onClick={() => onNavigate('inventoryHub')}>
        <i></i>
        INV.
      </button>
      <button
  className={`footer-btn footer-btn-2 ${
    currentPage === "tasks" ? "active" : ""
  }`}
  onClick={() => go("tasks")}
  style={{ position: "relative" }}
>
  <i></i>

  {hasTaskReward && (
    <span
      className="footer-live-dot"
      aria-label="Task reward available"
    />
  )}

  EARN
</button>
    </footer>
    </>
  );
}

export default Footer;